import { IAppWrapperProps } from './types.ts';
import { menuService } from './menuService.instance';
const LOG_IGNORE_CLASSES: Record<string, string[]> = {
  AppWrapper: ['MSG001', 'MSG500'],
  DataCache: ['MSG001', 'MSG002', 'MSG010'],
};

export const appWrapperProperties: IAppWrapperProps = {
  menuService,
  ignoreClasses: LOG_IGNORE_CLASSES,
};
